import { NavLink } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${(props) => props.backgroundColor || '#000'}!important;
  }
`;

export const BackgroundContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const NavMenuBackground = styled.div`
  position: relative;
  padding-top: 60px;

  ${(props) =>
    props.isVisible
      ? `  width: 100%;
          height: 100%;
          position: fixed;
          top: 60px;
          left: 0;
          background-color: rgba(8, 8, 8, 0.64);
          z-index:2;`
      : ''}
`;

export const NavMenu = styled.div`
  width: 280px;
  height: calc(100vh - 60px);
  top: 60px;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.colors.primary};
  position: fixed;
  transform: ${(props) =>
    props.isVisible ? 'translateX(0%)' : 'translateX(-100%)'};
  transition: transform 0.25s ease-out;
  z-index: 9999;
  overflow: scroll;

  &::after {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: blue;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 8px;
`;

export const Logo = styled.img`
  height: 44px;
  width: 117.08px;
`;

export const Wrapper = styled.div`
  padding-bottom: 120px;
`;

export const NameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 20px;
  margin-bottom: 5px;
  height: 50px;
  font-family: 'Barlow Condensed';
  font-weight: 600;
  font-size: 20px;
  text-decoration: none;
  color: #fff;
  justify-content: space-between;
`;

export const AccountsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 20px;
  margin-bottom: 20px;
`;
export const NavItemHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 5px 0 25px;
  height: 50px;
  font-family: 'Barlow Condensed';
  font-weight: 600;
  font-size: clamp(18px, 5.5vw, 22px);
  text-decoration: none;
  cursor: pointer;
  justify-content: space-between;

  color: #fff;

  &.active {
    background-color: ${(props) => props.theme.colors.secondary};
    border-radius: 8px;
  }

  &:active {
    color: #fff;
  }

  &:visited {
    color: #fff;
  }
`;

export const NavItem = styled(NavLink)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 20px;
  height: 50px;
  font-family: 'Barlow Condensed';
  font-weight: 600;
  font-size: clamp(18px, 5.5vw, 22px);
  text-decoration: none;

  color: #fff;
  margin-inline: 5px;

  &.active {
    background-color: ${(props) => props.theme.colors.secondary};
    border-radius: 8px;
  }

  &:active {
    color: #fff;
  }

  &:visited {
    color: #fff;
  }
`;

export const NavItemButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 20px;
  height: 50px;
  font-family: 'Barlow Condensed';
  font-weight: 600;
  font-size: clamp(18px, 5.5vw, 22px);
  text-decoration: none;

  color: #fff;
  margin-inline: 5px;

  &.active {
    background-color: ${(props) => props.theme.colors.secondary};
    border-radius: 8px;
  }

  &:active {
    color: #fff;
  }

  &:visited {
    color: #fff;
  }
`;

export const NavSubMenuText = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: 'Barlow Condensed';
  font-weight: 600;
  font-size: clamp(18px, 5.5vw, 22px);
  text-decoration: none;
  margin-top: 10px;

  color: #fff;
  margin-inline: 5px;

  &.active {
    background-color: ${(props) => props.theme.colors.secondary};
    border-radius: 8px;
  }

  &:active {
    color: #fff;
  }

  &:visited {
    color: #fff;
  }
`;

export const NavSubItem = styled(NavLink)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 20px;
  height: 50px;
  font-family: 'Barlow Condensed';
  font-weight: 600;
  font-size: clamp(18px, 5.5vw, 22px);
  text-decoration: none;
  padding-left: 40px;

  color: #fff;
  margin-inline: 5px;

  &.active {
    background-color: ${(props) => props.theme.colors.secondary};
    border-radius: 8px;
  }

  &:active {
    color: #fff;
  }

  &:visited {
    color: #fff;
  }
`;

export const NavItemExternal = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 20px;
  height: 50px;
  font-family: 'Barlow Condensed';
  font-weight: 600;
  font-size: clamp(18px, 5.5vw, 22px);
  text-decoration: none;

  color: #fff;
  margin-inline: 5px;

  &.active {
    background-color: ${(props) => props.theme.colors.secondary};
    border-radius: 8px;
  }

  &:active {
    color: #fff;
  }

  &:visited {
    color: #fff;
  }
`;

export const TopBar = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: ${(props) => props.theme.colors.primary};
  height: 60px;
  width: 100%;
  z-index: 9;
  top: 0;
`;

export const SettingsWrapper = styled.div`
  padding: 0 20px;
  margin: 0 20px 0 0;
  border-right: 1px solid #222222;
  height: 100%;
  display: flex;
  align-items: center;
`;
export const UserName = styled.div`
  font-family: 'Barlow Condensed';
  font-weight: 600;
  font-size: 16px;
  color: #fff;
  margin-bottom: 5px;
  margin-right: 50px;
`;
export const UserRole = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  opacity: 0.7;
  text-transform: uppercase;
`;
